var map = {
	"./de/triangle-icon.png": "MGnW",
	"./en/triangle-icon.png": "hUJ4",
	"./es/triangle-icon.png": "t853",
	"./fr/triangle-icon.png": "Xn5H",
	"./ja/triangle-icon.png": "gREO",
	"./ko/triangle-icon.png": "j4IS",
	"./pt/triangle-icon.png": "4Frr",
	"./ru/triangle-icon.png": "r2qS",
	"./tc/triangle-icon.png": "tyzv",
	"./th/triangle-icon.png": "0r0p"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A5jz";